// client/src/components/Shop/ShopLayout.tsx
import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import Footer from '../Layout/Footer';
import ShopFloatingLanguageSwitcher from './ShopFloatingLanguageSwitcher';
import './ShopWrapper.css';

interface ShopLayoutProps {
  children: React.ReactNode;
}

const ShopLayout: React.FC<ShopLayoutProps> = ({ children }) => {
  const { language } = useLanguage();

  return (
    <div className="shop-app" dir={language === 'ar' ? 'rtl' : 'ltr'} lang={language}>
      {/* Floating Language Switcher for Shop */}
      <ShopFloatingLanguageSwitcher />

      <div className="shop-wrapper">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default ShopLayout;